import React from "react";

// Source Data
import { testimonyData } from "../../source/aboutTestimonialSource";
export default function quoteTestimonyComponents() {
  return (
    <div className="quote_testimony">
      <div className="quote font-vietnam-600 mb-4">
        " Terkadang kita harus masuk jauh ke dalam diri kita sendiri untuk
        menyelesaikan masalah." - Patrick Star
      </div>
      <div className="divider"></div>
      <div className="testimony mt-4">
        <div className="title font-vietnam-400 font-size-14 text-uppercase">
          testimonial by
        </div>
        {testimonyData.map((item, index) => (
          <div className="content mb-2" key={index}>
            <div className="name font-size-18 font-vietnam-600">
              {item.name} - <span className="font-size-14">{item.role}</span>
            </div>
            <div className="opinion font-size-14 font-vietnam-300">
              {item.quote}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
